module.exports = __webpack_public_path__ + "static/media/driveamerica-2.179dbdc9.jpg";